import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import useFetch from 'use-http';

const LeaseTokenExample = () => {
    const appContext = useContext<IAppContextState>(AppContext);

    const { get, response } = useFetch();

    const [leaseTokens, setLeaseTokens] = useState<Array<{key: string, value: string}>>([]);
    const [dictionaryTokens, setDictionaryTokens] = useState<Array<{key: string, value: Array<{key: string, value: string }>}>>([]);
    useEffect(() => {
        getLeaseTokens();
    }, []);

    const getLeaseTokens = async () => {
        const result = await get(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/documentTemplate/template-tokens`);

        if (response.ok) {
            handleTokens(result);
        }
    };

    const handleTokens = (result: unknown) => {
        let newArray = new Array<{key: string, value: string }>();
        let dictionaryArray = new Array<{key: string, value: Array<{ key: string, value: string }>}>();

        for (const [key, value] of Object.entries(result)) {
            // Adding list of props in case this is expanded upon.
            let dictionaryProps = ['signatureBlocks'];

            if (dictionaryProps.includes(key)) {
                let dictionaryValues = [];
                for (const [dKey, dValue] of Object.entries(value)) {
                    dictionaryValues.push({ key: dKey, value: dValue as string });
                }
                dictionaryArray.push({key: key, value: dictionaryValues});
            } else {
                newArray.push({ key: key, value: value });
            }                
        }
        newArray.sort((a, b) => {
            if (a.key < b.key) {
                return -1;
            }
            if (a.key > b.key) { 
                return 1;
            }
            return 0;
        });
        dictionaryArray.sort((a, b) => {
            if (a.key < b.key) {
                return -1;
            }
            if (a.key > b.key) { 
                return 1;
            }
            return 0;
        });

        setLeaseTokens(newArray);
        setDictionaryTokens(dictionaryArray);
    };

    const displayLeaseTokens = (tokenList: Array<{key: string, value: string}>) => {
        let tokenRows = [];

        for (let i = 0; i < tokenList.length; i += 2) {
            tokenRows.push(leaseTokenRow(tokenList, i));
        }

        return tokenRows;
    };

    const displayDictionaryTokens = (tokenList: Array<{key: string, value: Array<{key: string, value: string }>}>) => {
        let dictionaryRows = [];
        
        for (let i = 0; i < tokenList.length; i++) {
            dictionaryRows.push(
                <div
                    key={tokenList[i].key}
                >
                    <span>{tokenList[i].key}</span>
                    <div style={{ marginLeft: '1rem' }}>
                        {displayLeaseTokens(tokenList[i].value)}
                    </div>
                </div>
            );
        }

        return dictionaryRows;
    };

    const leaseTokenRow = (tokenList: Array<{key: string, value: string}>, currentIndex: number) => {
        let tokenHtml = [];

        for (let i = currentIndex; i < tokenList.length && i < currentIndex + 2; i++) {
            tokenHtml.push(
                <div
                    key={tokenList[i].key}
                    style={{ justifyContent: 'flex-start', width: '50%' }}
                >
                    <span>{`{${tokenList[i].key}} - `}</span>
                    <span>{tokenList[i].value}</span>
                </div>
            );
        }

        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                {tokenHtml}
            </div>
        );
    };

    return (
        <div>
            <div style={{ textAlign: 'center', fontSize: '2.2rem' }}>Lease Template Tokens</div>

            {leaseTokens.length > 0 && (
                <div style={{ marginLeft: '1rem' }}>
                    {displayLeaseTokens(leaseTokens)}
                </div>
            )}
            {dictionaryTokens.length > 0 && (
                <div style={{ marginLeft: '1rem' }}>
                    {displayDictionaryTokens(dictionaryTokens)}
                </div>
            )}
        </div>
    );
};

export default LeaseTokenExample;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/LeaseTokenExample.tsx